import React, { useEffect, useRef, useState } from 'react';
import { findFirstRenderRowIndex } from "./utils";
import { SCROLL_TO_TYPE } from "./..";
import { cn } from "../../helpers";
import { styles } from './styles';
var ON_SCROLL_DEBOUNCE_TIME_IN_MS = 50;
var SCROLLING_DEBOUNCE_TIME_IN_MS = 250;
export var VScrollList = React.memo(function VScrollList(props) {
    var rows = [];
    var ref = useRef(null);
    var rootRef = props.bodyRef || ref;
    var self = useState({
        scrollTop: 0,
        scrollLeft: 0,
        scrollDirection: 1,
        rowParams: [],
        renderListStartIdx: 0,
        onScrollCallbackDebounceId: 0,
        requestFrameId: 0,
        startScrollId: 0
    })[0];
    var _a = useState(0), renderListStartIdx = _a[0], setRenderListStartIdx = _a[1];
    useEffect(function () {
        var _a;
        var startScroll = function () {
            var _a;
            if (self.startScrollId) {
                window.clearTimeout(self.startScrollId);
            }
            else {
                (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.classList.add(styles.scrolling);
            }
            self.startScrollId = window.setTimeout(function () {
                var _a;
                (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.classList.remove(styles.scrolling);
                window.clearTimeout(self.startScrollId);
                self.startScrollId = 0;
            }, SCROLLING_DEBOUNCE_TIME_IN_MS);
        };
        var onScroll = function (e) {
            if (!e.target) {
                return;
            }
            startScroll();
            if (self.onScrollCallbackDebounceId) {
                window.clearTimeout(self.onScrollCallbackDebounceId);
            }
            self.onScrollCallbackDebounceId = window.setTimeout(function () {
                var cb = function () {
                    var _a;
                    var target = e.target;
                    var prevScrollTop = self.scrollTop;
                    var prevScrollLeft = self.scrollLeft;
                    var nextScrollTop = (target === null || target === void 0 ? void 0 : target.scrollTop) || 0;
                    var nextScrollLeft = (target === null || target === void 0 ? void 0 : target.scrollLeft) || 0;
                    self.scrollTop = nextScrollTop;
                    var isUpDirection = self.scrollTop < prevScrollTop;
                    self.scrollDirection = isUpDirection ? 0 : 1;
                    var nextRowStartIdx = findFirstRenderRowIndex({
                        offsetAddon: 0,
                        scrollTop: nextScrollTop,
                        totalCount: props.totalCount,
                        rowsParams: self.rowParams
                    }) - Math.floor(props.rowsLimit / 3);
                    var prevRenderListStartIdx = self.renderListStartIdx;
                    self.renderListStartIdx = nextRowStartIdx;
                    if (prevRenderListStartIdx !== nextRowStartIdx) {
                        setRenderListStartIdx(nextRowStartIdx);
                    }
                    (_a = props.onScroll) === null || _a === void 0 ? void 0 : _a.call(props, {
                        scrollTop: nextScrollTop,
                        scrollLeft: nextScrollLeft,
                        isXScroll: prevScrollLeft !== nextScrollLeft,
                        isYScroll: prevScrollTop !== nextScrollTop
                    });
                };
                self.requestFrameId = requestAnimationFrame(cb);
            }, ON_SCROLL_DEBOUNCE_TIME_IN_MS);
        };
        (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
        return function () {
            var _a;
            (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll);
            if (self.onScrollCallbackDebounceId) {
                window.clearTimeout(self.onScrollCallbackDebounceId);
            }
            if (self.startScrollId) {
                window.clearTimeout(self.startScrollId);
            }
            if (self.requestFrameId) {
                cancelAnimationFrame(self.requestFrameId);
            }
            self.onScrollCallbackDebounceId = 0;
            self.requestFrameId = 0;
            self.startScrollId = 0;
        };
    }, [props.onScroll, props.totalCount, props.rowsLimit]);
    var topOffset = 0;
    // TODO: why not from renderListStartIdx to renderListStartIdx + rowsLimit? If refactoring topOffset can we fix it?
    for (var index = 0; index < props.totalCount; index++) {
        var height = props.rowHeightGetter(index);
        self.rowParams[index] = {
            topOffset: topOffset,
            height: height
        };
        if (index >= renderListStartIdx && index <= renderListStartIdx + props.rowsLimit) {
            rows.push(props.rowRenderer({
                index: index,
                topOffset: topOffset,
                height: height,
                width: props.rowWidth
            }));
        }
        topOffset += height;
    }
    useEffect(function () {
        if (props.apiRef) {
            props.apiRef.current = {
                scrollTo: function (config) {
                    var _a, _b, _c;
                    if (config.type === SCROLL_TO_TYPE.top) {
                        (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: self.rowParams[160].topOffset });
                    }
                    if (config.type === SCROLL_TO_TYPE.bottom) {
                        var viewPortHeight = ((_b = rootRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) || 0;
                        (_c = rootRef.current) === null || _c === void 0 ? void 0 : _c.scrollTo({
                            top: self.rowParams[160].topOffset -
                                viewPortHeight +
                                self.rowParams[160].height
                        });
                    }
                }
            };
        }
    }, []);
    return React.createElement('div', {
        key: 'root',
        ref: rootRef,
        className: cn('vm-VScroll', styles.root)
    }, React.createElement('div', {
        key: 'inner',
        className: cn('vm-VScroll__inner', styles.inner),
        style: {
            height: topOffset,
            minHeight: topOffset,
            maxHeight: topOffset
        }
    }, rows));
});
//# sourceMappingURL=VScrollList.js.map